/**
 * @generated SignedSource<<5d38c3647e0ee554a60d1eb4fcecbd13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "answerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "formFieldId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ignoredAnswerIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryText"
},
v4 = [
  {
    "kind": "Variable",
    "name": "answerId",
    "variableName": "answerId"
  },
  {
    "kind": "Variable",
    "name": "formFieldId",
    "variableName": "formFieldId"
  },
  {
    "kind": "Variable",
    "name": "ignoredAnswerIds",
    "variableName": "ignoredAnswerIds"
  },
  {
    "kind": "Variable",
    "name": "queryText",
    "variableName": "queryText"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSimilarAnswersFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "similarAnswers",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "formAnswer",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Contribution",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSimilarAnswersFetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "similarAnswers",
        "plural": true,
        "selections": [
          (v6/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "formAnswer",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e5217df1e78b5ffc02aeadfa1af6cd1b",
    "id": null,
    "metadata": {},
    "name": "useSimilarAnswersFetchQuery",
    "operationKind": "query",
    "text": "query useSimilarAnswersFetchQuery(\n  $queryText: String!\n  $formFieldId: ID!\n  $answerId: ID\n  $ignoredAnswerIds: [ID!]\n) {\n  similarAnswers(queryText: $queryText, formFieldId: $formFieldId, answerId: $answerId, ignoredAnswerIds: $ignoredAnswerIds) {\n    __typename\n    id\n    formAnswer {\n      __typename\n      ... on Contribution {\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "51d699238e5834bc0d9ce2a960f44a54";

module.exports = node;
